import { Stands } from '../Stands';
import { AppConfigs } from './AppConfigs/AppConfigs';

export const services = {
	clientAdminApi: 'clientAdminApi',
	fileLoadApi: 'fileLoadApi',
	orderAdminApi: 'orderAdminApi',
};

const gateway = {
	[Stands.test]: 'https://admin-api.efrtest.ru',
	[Stands.cert]: 'https://admin-api.efrcert.ru',
	[Stands.prod]: 'https://admin-api.efr.ru',
};

export const efrAdminBotPaths = [];

export const appEfrAdminConfig = new AppConfigs<typeof services>({
	servicesHosts: Object.fromEntries(
		Object.keys(services).map((key) => [key, gateway]),
	) as Record<keyof typeof services, typeof gateway>,
	appHostName: 'efrAdmin',
});
export type AppEfrAdminConfig = AppConfigs<typeof services>;
